import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import { getApiUrl } from './config/api';
import LanguageSwitcher from './components/LanguageSwitcher';

function RankedElectionsList() {
    const [rankedElections, setRankedElections] = useState([]);

    useEffect(() => {
        fetch(getApiUrl('/api/ranked-elections'))
            .then(response => response.json())
            .then(data => setRankedElections(data))
            .catch(error => console.error('Error fetching ranked elections:', error));
    }, []);

    return (
        <div>
            <div className="language-switcher-container position-fixed top-0 end-0 m-3" style={{ zIndex: 1000 }}>
                <LanguageSwitcher />
            </div>
            
            <h2>Ranked Elections</h2>
            <ul>
                {rankedElections.map(election => (
                    <li key={election.id}>
                        <Link to={`/ranked-elections/${election.id}`}>
                            {election.title}
                        </Link>
                    </li>

                ))}
            </ul>
        </div>
    );
}

export default RankedElectionsList;